import myHeader from "../../components/header.vue"
import myFooter from "../../components/footer.vue"
import {loginByPost} from "../../api/service.js"
import {addOrderPaymentPost,getOrderPaymentGet} from "../../api/service";
let that;
export default{
    components:{
        myHeader,
        myFooter
    },
    data(){
        return{
          dialogVisible:false,
          rules: {
            ordEmpName: [
              {required: true, message: '请输入员工姓名', trigger: 'blur'}
            ],
            ordEmpSex: [
              {required: true, message: '请选择性别', trigger: 'blur'}
            ],
            ordEntpName: [
              {required: true, message: '请输入单位名称', trigger: 'blur'}
            ],
            ordEmpTel: [
              {required: true, message: '请输入手机号码', trigger: 'blur'}
            ],
          },
          applyObj:{},
          isQuery:false,
          money:0,
          ordNum:1,
          ordType:1,
          ordDetails:"",
          ordPayType:1,
          payImgUrl:"",
          payStatus:false,
          ordNo:"",
          countDown:60,
          interval:{},interval2:{},
          outerVisible:false
        }
    },
    created(){
        that=this;
        var wUrl=window.location.href;
        var param=wUrl.substring(wUrl.indexOf("?")+1,wUrl.indexOf("?")+11);
        if(param=="isPay=true"){
          that.outerVisible=true;
        }
    },
    methods:{
     openIntentional(money,ordType,ordDetails){
       that.dialogVisible=true;
       that.payStatus=false;
       that.ordDetails=ordDetails;
       that.money=money;
       that.ordType=ordType;
       that.isQuery=false;
       that.applyObj={};
       that.ordNum=1;
       that.ordPayType="1";
     },
      goBaoming(){
        $('html').scrollTop($('html')[0].scrollHeight);
      },
      save(formName){
        this.$refs[formName].validate((valid) => {
          if (valid) {

          } else {
            console.log('error submit!!');
            this.$message.error("请检查必填数据是否填写完整");
            var staff_top = $('#imgUploader').offset().top;
            $('#formStaffId').animate({scrollTop: staff_top}, 500);
            return false;
          }
        });
        that.applyObj.ordAmount=that.money*that.ordNum;
        that.applyObj.ordNum=that.ordNum;
        that.applyObj.ordType=that.ordType;
        that.applyObj.ordDetails=that.ordDetails;
        that.applyObj.ordPayType=that.ordPayType;
       var url="order/addOrderPayment";
        addOrderPaymentPost(url,that.applyObj).then(res=>{
          if(res.success){
            that.isQuery=true;
            if (that.ordPayType=="0"){
              that.payImgUrl="data:image/jpg;base64,"+res.data.binary;
              that.ordNo=res.data.ordNo;

            var interval=setInterval(function () {
                if(that.payStatus){
                  clearInterval(interval);
                }
              if(that.countDown==0||that.countDown<0){
                clearInterval(interval);
              }
                that.getPayStatus();
              },5000);
              var interval2=setInterval(function () {
                that.countDown=that.countDown-1;
                if(that.countDown==0||that.countDown<0){
                  clearInterval(interval2);
                  that.payImgUrl="../../../static/guoqi.png"
                }
              },1000)

            }else{
              this.$router.push({
                path:"/Alipay",
                query:{
                  htmls:res.data,
                }
              })
            }
          }
        })

      },
      reCreateQRCode(){
        var url="order/reCreateQRCode";
        that.countDown=60;
        var param={ordNo:that.ordNo};
        getOrderPaymentGet(url,param).then(res=>{
          if(res.success){
            that.payImgUrl="data:image/jpg;base64,"+res.data;
            var interval3=setInterval(function () {
              if(that.payStatus){
                clearInterval(interval3);
              }
              if(that.countDown==0||that.countDown<0){
                clearInterval(interval3);
              }
              that.getPayStatus();
            },5000);
             var interval5=setInterval(function () {
              that.countDown=that.countDown-1;
              if(that.countDown==0||that.countDown<0){
                clearInterval(interval5);
                that.payImgUrl="../../../static/guoqi.png"
              }
            },1000)
          }
        })
      },
      getPayStatus(){
        var url="pay/search";
        var param={ordNo:that.ordNo};
        getOrderPaymentGet(url,param).then(res=>{
          if(res.success){
            that.payStatus=res.success;
          }
        })
      }
    }
}



// WEBPACK FOOTER //
// ./src/pages/intentional-purchase/intentional-purchase.js